var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5782",
    "data-name": "Group 5782",
    transform: "translate(-1106 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_863",
    "data-name": "Ellipse 863",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1106 477)",
    fill: "#e6f4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28836",
    "data-name": "Path 28836",
    d: "M9,12.75,11.25,15,15,9.75M21,12a9,9,0,1,1-9-9A9,9,0,0,1,21,12Z",
    transform: "translate(1119.5 490.5)",
    fill: "none",
    stroke: "#309b4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCartIcon);
export default __webpack_public_path__ + "static/media/reviewCartIcon.80775ee1694244c49338151f6d7977c6.svg";
export { ForwardRef as ReactComponent };